
.edecide-panel {

    .container-fluid {
        margin: 0;
        padding: 0;
    }

    .row {
        margin: 0;
        padding: .3rem 0 2rem 0;
    }

    .display-label {
        margin: 0;
        padding: 0;
    }

    ul.documents {
        margin: 0;
        padding: 0;
        list-style: none;

        li {
            margin: 0;
            padding: 2px 0 2px;
            line-height: normal;
            position: relative;
        }

        i {
            position: absolute;
            top: 3px;
            left: 0;
            width: 16px;
            height: 16px;
            background-repeat: no-repeat;
            background-position: 0 0;
            margin: 0;
        }
    }
}
